import { ArgsType, Field, Int } from '@nestjs/graphql'
import { IsOptional, MaxLength } from '@nestjs/class-validator'
import { BaseUpdateDto } from '../base/baseUpdate.dto'

@ArgsType()
export class UpdateArcDto extends BaseUpdateDto<UpdateArcDto> {
  @Field(type => Int, { nullable: true })
  bookId?: number

  @Field(type => Int, { nullable: true })
  arcTeamId?: number

  // DB column is VarChar(500); without this an over-long value 500s at prisma.arc.update.
  // The author form validates per field, but any other field's auto-save sends the whole
  // crud model, so the API has to enforce the limit itself. IsOptional is required or
  // MaxLength rejects requests that omit (or null) the field. [sc-27360]
  @Field({ nullable: true })
  @IsOptional()
  @MaxLength(500, { message: 'maxLength' })
  specialInformation?: string

  @Field(type => Int, { nullable: true })
  arcType?: number

  @Field(type => Int, { nullable: true })
  discoverableType?: number

  @Field(type => Int, { nullable: true })
  participationType?: number

  @Field(type => Int, { nullable: true })
  participationPreventionType?: number

  @Field(type => Int, { nullable: true })
  siteWideParticipationPreventionType?: number

  @Field(type => Int, { nullable: true })
  copyCountType?: number

  @Field(type => Int, { nullable: true })
  copyCount?: number | null

  @Field(type => Int, { nullable: true })
  seriesLimitType?: number

  @Field(type => Int, { nullable: true })
  reviewFlags?: number

  @Field(type => Int, { nullable: true })
  optionalReviewFlags?: number

  @Field(type => Int, { nullable: true })
  requiredReviewCount?: number

  @Field({ nullable: true })
  liveDate?: Date

  @Field(type => Int, { nullable: true })
  reviewDays?: number

  @Field({ nullable: true })
  stopDownloadDate?: Date

  @Field(type => Boolean, { nullable: true })
  neverEndingPrivate?: boolean

  @Field({ nullable: true })
  usDownloadCodes?: string

  @Field({ nullable: true })
  ukDownloadCodes?: string

  @Field({ nullable: true })
  authorsDirectDownloadCodes?: string

  @Field({ nullable: true })
  koboDownloadCodes?: string

  @Field(t => Int, { nullable: true })
  vipExclusiveAccessDays?: number

  @Field({ nullable: true })
  dueDate?: Date

  @Field(type => Boolean, { nullable: true })
  reviewLinksCompleted?: boolean

  @Field(t => Int, { nullable: true })
  alertFlags?: number

  @Field({ nullable: true })
  liveDateStr?: string

  @Field({ nullable: true })
  stopDownloadDateStr?: string

  @Field({ nullable: true })
  dueDateStr?: string

  @Field({ nullable: true })
  dueCutOffDateStr?: string
}
